import { supabase } from '../supabaseClient';

const RIDER_DIRECTORY_COLUMNS = 'id, name, staff_id, balance, restaurant_id';
const RIDER_DIRECTORY_FALLBACK = 'id, name, balance, restaurant_id';

export const getRiderPortalRestaurantId = () =>
  localStorage.getItem('currentRestaurantId')
  || localStorage.getItem('rider_portal_restaurant_id')
  || process.env.REACT_APP_DEFAULT_RESTAURANT_ID
  || '';

export const setRiderPortalRestaurantId = (restaurantId) => {
  const id = String(restaurantId || '').trim();
  if (!id) return;
  localStorage.setItem('rider_portal_restaurant_id', id);
  localStorage.setItem('currentRestaurantId', id);
};

export const fetchRiderDirectory = async (restaurantId) => {
  if (!restaurantId) {
    return { data: [], error: new Error('Restaurant not selected on this device.') };
  }

  let result = await supabase
    .from('riders')
    .select(RIDER_DIRECTORY_COLUMNS)
    .eq('restaurant_id', restaurantId)
    .order('name');

  if (result.error && /staff_id|column/i.test(result.error.message || '')) {
    result = await supabase
      .from('riders')
      .select(RIDER_DIRECTORY_FALLBACK)
      .eq('restaurant_id', restaurantId)
      .order('name');
  }

  return result;
};

export const linkRiderToStaff = async (riderId, staffId, restaurantId) => {
  const { error } = await supabase
    .from('riders')
    .update({ staff_id: Number(staffId) })
    .eq('id', riderId)
    .eq('restaurant_id', restaurantId);

  return { error };
};

export const createRiderSession = async ({ riderId, staffId, restaurantId }) => {
  const { data, error } = await supabase.rpc('create_rider_session', {
    p_rider_id: Number(riderId),
    p_staff_id: staffId ? Number(staffId) : null,
    p_device_label: `${navigator.platform || 'device'} rider portal`,
    p_user_agent: navigator.userAgent || '',
    p_expires_hours: 12,
    p_restaurant_id: restaurantId,
  });

  if (error) return { data: null, error };
  return { data: Array.isArray(data) ? data[0] || null : data, error: null };
};

export const validateRiderSession = async ({ token, restaurantId }) => {
  if (!token || !restaurantId) {
    return { data: null, error: new Error('Rider session is missing.') };
  }

  const { data, error } = await supabase.rpc('validate_rider_session', {
    p_session_token: token,
    p_restaurant_id: restaurantId,
  });

  if (error) return { data: null, error };
  return { data: Array.isArray(data) ? data[0] || null : data, error: null };
};

export const revokeRiderSession = async ({ token, restaurantId, reason = 'logout' }) => {
  if (!token || !restaurantId) return { data: false, error: null };

  const { data, error } = await supabase.rpc('revoke_rider_session', {
    p_session_token: token,
    p_reason: reason,
    p_restaurant_id: restaurantId,
  });

  return { data, error };
};
